module.exports = __webpack_public_path__ + "static/media/teaching_server_icon_3.d6b62d20.svg";